import { searchoptionApi } from '@/api/schoolMajor/index'
export default {
  namespaced: true,
  state: {
    eList: []
  },
  mutations: {
    SET_SEARCHOPTIONLIST(state, data) {
      state.eList = data
    }
  },
  actions: {
    searchoptionList({ commit }) {
      searchoptionApi().then(res => {
        res.data.push({ value: -1, text: '未知' })
        commit('SET_SEARCHOPTIONLIST', res.data)
      })
    }
  }
}